import { render, staticRenderFns } from "./SitePosterSvgNew.vue?vue&type=template&id=20f7b82e&"
import script from "./SitePosterSvgNew.vue?vue&type=script&lang=js&"
export * from "./SitePosterSvgNew.vue?vue&type=script&lang=js&"
import style0 from "./SitePosterSvgNew.vue?vue&type=style&index=0&id=20f7b82e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports